import React, { useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@tyrannosaurustech/ui";

import { TitleM } from "../../../components/atoms/Typography";
import { ContentWrapper } from "../../../components/ContentWrapper";
import { Breadcrumb } from "../../../components/molecules/Breadcrumb";
import { useCreateFirmMutation } from "../../../redux/reduxQuery/firmApi";
import { useMutationWrapper } from "../../../common/api";
import LawFirmForm, { LawFirmFormRef } from "./components/LawFirmForm";

export default function CreateLawFirm() {
  const [createLawFirm] = useCreateFirmMutation();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  let navigate = useNavigate();
  const formRef = useRef<LawFirmFormRef>(null);

  const mutate = useMutationWrapper(
    createLawFirm,
    `Law Firm Successfully Created`,
    (data) =>
      navigate(`/admin/law-firms/${data.id}`, {
        state: { openBulkAddUsers: true },
      })
  );

  const handleFormSubmit = async (data: any) => {
    setIsProcessing(true);
    try {
      await mutate({ ...data, state: data.state });
    } finally {
      setIsProcessing(false);
    }
  };

  const handleFormCancel = () => {
    navigate("/admin/law-firms");
  };

  const handleFormStateChange = useCallback(
    (dirty: boolean, valid: boolean) => {
      setIsFormDirty(dirty);
      setIsFormValid(valid);
    },
    []
  );

  const crumbLinks = [
    {
      text: "Law Firms",
      path: "/admin/law-firms",
    },
    {
      text: "Add New Law Firm",
    },
  ];

  return (
    <ContentWrapper>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1.5rem 0",
        }}
      >
        <div>
          <Breadcrumb crumbs={crumbLinks} />
          <TitleM>Add New Law Firm</TitleM>
        </div>
        <div style={{ display: "flex", gap: "1rem", height: "fit-content" }}>
          {" "}
          <Button
            type="button"
            base="secondary"
            onClick={handleFormCancel}
            label="Cancel"
          />
          <Button
            type="submit"
            label="Create Law Firm"
            loading={isProcessing}
            onClick={() => {
              if (formRef.current) {
                formRef.current.handleSubmit(handleFormSubmit)();
              }
            }}
            disabled={!isFormDirty || !isFormValid}
          />
        </div>
      </div>
      <LawFirmForm
        ref={formRef}
        onFormSubmit={handleFormSubmit}
        onFormCancel={handleFormCancel}
        isProcessing={isProcessing}
        renderButtonsExternal={true}
        onFormStateChange={handleFormStateChange}
      />
      <div
        style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "flex-end",
          marginTop: "1rem",
          marginBottom: "2.5rem",
        }}
      >
        <Button
          type="button"
          base="secondary"
          onClick={handleFormCancel}
          label="Cancel"
        />
        <Button
          type="submit"
          label="Create Law Firm"
          loading={isProcessing}
          onClick={() => {
            if (formRef.current) {
              formRef.current.handleSubmit(handleFormSubmit)();
            }
          }}
          disabled={!isFormDirty || !isFormValid}
        />
      </div>
    </ContentWrapper>
  );
}
